// extracted by mini-css-extract-plugin
export default {"customer_box":"o3Pv4yYvGtTQXmJNOnp_","ms-Link":"oWcXurBnBM8ZEnukHUIp","cid_box":"zpHmH1UT2XiZCopwMtIJ","cid_container":"YIdTmNNdd6kcSD5tjqLJ","cid_title":"o8TU2KePYeP_so6_Uf7v"};